import { useState, useEffect, useContext } from 'react'
import { Grid, Typography, Button, FormControl, InputLabel, Select, MenuItem, Paper, IconButton, Modal, Box, TextField, Tooltip } from '@mui/material'
import { DataGrid } from '@mui/x-data-grid'
import { withStyles } from "@material-ui/core/styles"
import { DatePicker } from '@mui/x-date-pickers'
import { LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { httpRequest } from '../../../../../ui-utils/api'
import snackError from '../../../../../helpers/snackError'
import { reducerContext } from '../../../../../contextApi\'s/contextApi\'s'
import EditIcon from "@mui/icons-material/Edit";
import CloseIcon from "@mui/icons-material/Close";
import dayjs from "dayjs";
import { Download } from '@mui/icons-material'
import { apiUrl, backendHosts } from '../../../../../ui-utils/apiConfig'
import exportFromJSON from 'export-from-json'
import styles from './userProfilesStyles'

const style = {
    position: "absolute !important",
    top: "50% !important",
    left: "50% !important",
    transform: "translate(-50%, -50%) !important",
    width: "50% !important",
    bgcolor: "background.paper",
    boxShadow: 24,
    p: 4,
    borderRadius: "15px !important",
    "@media only screen and (max-width: 1650px)": {
        width: "80% !important",
    },
}

const UserProfile = ({ classes }) => {
    const { dispatch } = useContext(reducerContext)

    const [Fdate, setFdate] = useState(dayjs().format('YYYY-MM-DD'))
    const [Tdate, setTdate] = useState(dayjs().format('YYYY-MM-DD'))
    const [status, setStatus] = useState('Pending')
    const [userList, setUserList] = useState([])
    const [columns, setColumns] = useState([])
    const [fterror, setFTError] = useState("")
    const [editModal, setEditModal] = useState(false)
    const [userData, setUserData] = useState({})

    const [rejectionRemarks, setRejectionRemarks] = useState('')
    const [changeStatus, setChangeStatus] = useState("")
    const [remarkErr, setRemarkErr] = useState("")

    const [filteredList, setFilteredList] = useState([])
    const [updateType, setUpdateType] = useState([])
    const [selectUpdateType, setSelectUpdateType] = useState("all")

    const userName = localStorage.getItem('username')
    const agentId = localStorage.getItem('user_id1')


    const handleFetchUserList = async () => {
        try {
            const userResult = await httpRequest({
                endPoint: `${backendHosts.BACK_OFFICE}${apiUrl.userProfileQuery}`,
                method: "get",
                instance: "instanceTwo",
                params: {
                    status: status.toLowerCase()
                }
            })

            if (userResult.status === 200 && userResult.data?.success) {
                const { result } = userResult.data
                setUserList(result)
                setFilteredList(result)

                const types = ["all",...new Set(result.map((item) => item.update_type))]
                setUpdateType(types)
            } else {
                dispatch({ type: 'SET_SHOW_ERROR', payload: true })
                dispatch({ type: 'SET_ERROR', payload: 'Error in fetching user profile List' })
                dispatch({ type: 'SET_MY_SNACK', payload: snackError.myError })
                console.log("Error in fetching user profile List", userResult)
            }
        } catch (error) {
            dispatch({ type: 'SET_SHOW_ERROR', payload: true })
            dispatch({ type: 'SET_ERROR', payload: 'Error in fetching user profile List' })
            dispatch({ type: 'SET_MY_SNACK', payload: snackError.myError })
            console.log("Error in fetching user profile List", error)
        }
    }

    useEffect(() => {
        if (status) {
            handleFetchUserList()
        }
    }, [status])

    const handleFDate = (newValue) => {
        setFdate(dayjs(newValue).format('YYYY-MM-DD'))
    }

    const handleTDate = (newValue) => {
        setTdate(dayjs(newValue).format('YYYY-MM-DD'))
    }

    const handleReset = () => {
        setFdate(null)
        setTdate(null)
        setFTError("")
        setStatus("Pending")
        setSelectUpdateType("all")
    }

    const handleStatusChangeDropDown = (e) => {
        setStatus(e.target.value)
    }

    const handleFormSubmit = async (e) => {
        e.preventDefault()
        if (Fdate === null) {
            setFTError("From Date is required *")
            return
        }

        if (Tdate === null) {
            setFTError(" To Date is required *")
            return
        }

        if (Fdate !== null || Tdate !== null) {
            setFTError("")
        }

        try {
            const userResult = await httpRequest({
                endPoint: `${backendHosts.BACK_OFFICE}${apiUrl.userProfileQuery}`,
                method: "get",
                instance: "instanceTwo",
                params: {
                    status: status.toLowerCase(),
                    from: Fdate,
                    to: Tdate
                }
            });


            if (userResult.status === 200 && userResult.data?.success) {
                const { result } = userResult.data
                setUserList(result)
                setFilteredList(result)

                const types = ["all", ...new Set(result.map((item) => item.update_type))]
                setUpdateType(types)

            } else {
                dispatch({ type: 'SET_SHOW_ERROR', payload: true })
                dispatch({ type: 'SET_ERROR', payload: 'Error in fetching user profile List' })
                dispatch({ type: 'SET_MY_SNACK', payload: snackError.myError })
                console.log("Error in fetching user profile List", userResult)
            }
        } catch (error) {
            dispatch({ type: 'SET_SHOW_ERROR', payload: true })
            dispatch({ type: 'SET_ERROR', payload: 'Error in fetching user profile List' })
            dispatch({ type: 'SET_MY_SNACK', payload: snackError.myError })
            console.log("Error in fetching user profile List", error)
        }
    }

    const handleEditModal = (row) => {
        setEditModal(true)
        setUserData(row)
    }

    const handleClose = () => {
        setEditModal(false)
        setUserData({})
        setChangeStatus("")
        setRejectionRemarks("")
        setRemarkErr("")
    }

    const handleSaveStatusChange = async (userId) => {
        const payload = {
            verification_status: changeStatus,
            verified_by: `${userName}-${agentId}`,
            verified_comments: rejectionRemarks,
            clientId: userData?.client_id
        }



        if (changeStatus === "rejected") {
            if (rejectionRemarks.trim().length === 0) {
                setRemarkErr("Please add remarks")
                return
            }
        }

        try {
            const userResult = await httpRequest({
                endPoint: `${backendHosts.BACK_OFFICE}${apiUrl.userProfileVerify}/${userId}`,
                method: "put",
                instance: "instanceOne",
                requestBody: payload
            })

            if (userResult.status === 200 && userResult.data.success) {
                handleClose()
                handleFetchUserList()
                dispatch({ type: 'SET_SHOW_ERROR', payload: true })
                dispatch({ type: 'SET_ERROR', payload: userResult.data.message })
                dispatch({ type: 'SET_MY_SNACK', payload: snackError.mySucc })

            } else {
                dispatch({ type: 'SET_SHOW_ERROR', payload: true })
                dispatch({ type: 'SET_ERROR', payload: `Error in updating user profile status` })
                dispatch({ type: 'SET_MY_SNACK', payload: snackError.myError })
                console.log(`Error in updating user profile status`, userResult)
            }

        } catch (error) {
            dispatch({ type: 'SET_SHOW_ERROR', payload: true })
            dispatch({ type: 'SET_ERROR', payload: `Error in updating user profile status` })
            dispatch({ type: 'SET_MY_SNACK', payload: snackError.myError })
            console.log(`Error in updating user profile status`, error)
        }
    }

    const downloadDocument = async (filename, userId, clientId) => {

        try {
            const userResult = await httpRequest({
                endPoint: `${backendHosts.BACK_OFFICE}${apiUrl.userProfilePdf}/${userId}/${clientId}`,
                method: "get",
                instance: "instanceOne"
            })

            if (userResult.status === 200 && userResult.data?.success) {
                const base64 = userResult.data.data

                const byteCharacters = atob(base64)
                const byteNumbers = new Array(byteCharacters.length)

                for (let i = 0; i < byteCharacters.length; i++) {
                    byteNumbers[i] = byteCharacters.charCodeAt(i);
                }

                const byteArray = new Uint8Array(byteNumbers);
                const blob = new Blob([byteArray], { type: 'application/pdf' })

                /// Create object URL and trigger download
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.download = filename;
                link.click();

                // Clean up the object URL
                window.URL.revokeObjectURL(url)

            } else {
                dispatch({ type: 'SET_SHOW_ERROR', payload: true })
                dispatch({ type: 'SET_ERROR', payload: `Error in fetching ${filename}` })
                dispatch({ type: 'SET_MY_SNACK', payload: snackError.myError })
                console.log(`Error in fetching ${filename}`, userResult)
            }

        } catch (error) {
            dispatch({ type: 'SET_SHOW_ERROR', payload: true })
            dispatch({ type: 'SET_ERROR', payload: `Error in fetching ${filename}` })
            dispatch({ type: 'SET_MY_SNACK', payload: snackError.myError })
            console.log(`Error in fetching ${filename}`, error)
        }
    }

    useEffect(() => {
        const dynamicColumns = [
            {
                field: "created_at",
                headerName: "Request Date",
                align: "center",
                headerAlign: "center",
                flex: 1,
                valueFormatter: (params) => {
                    return params != null ? params?.split("T")[0] : '-'
                }

            },
            {
                field: "client_id",
                headerName: "Client ID",
                align: "center",
                headerAlign: "center",
                flex: 1,
            },
            {
                field: "full_name",
                headerName: "Name",
                align: "center",
                headerAlign: "center",
                flex: 1,
            },
            {
                field: "email",
                headerName: "Email",
                align: "center",
                headerAlign: "center",
                flex: 1,
            },
            {
                field: "mobile_number",
                headerName: "Phone No",
                type: "number",
                align: "center",
                headerAlign: "center",
                flex: 1,
            },
            {
                field: "verification_status",
                headerName: "Status",
                align: "center",
                headerAlign: "center",
                flex: 1,
            },
        ];


        if (status !== "Pending") {
            dynamicColumns.push(
                {
                    field: "verified_at",
                    headerName: status === "Rejected" ? "Rejected On" : "Approved On",
                    align: "center",
                    headerAlign: "center",
                    flex: 1,
                    valueFormatter: (params) => {
                        return params != null ? params?.split("T")[0] : '-'
                    }
                },
                {
                    field: "verified_by",
                    headerName: status === "Rejected" ? "Rejected By" : "Approved By",
                    align: "center",
                    headerAlign: "center",
                    flex: 1,
                },

            );
        }

        if (status === "Rejected") {
            dynamicColumns.push(
                {
                    field: "verified_comments",
                    headerName: "Remark",
                    align: "center",
                    headerAlign: "center",
                    flex: 1,
                },
            )
        }


        if (status === "Pending" || "Rejected" || "Approved") {
            dynamicColumns.push({
                field: "actions",
                headerName: "Action",
                align: "center",
                headerAlign: "center",
                flex: 1,
                renderCell: (params) => (
                    <IconButton onClick={() => handleEditModal(params.row)} className={classes.edtIcnClr}>
                        <EditIcon style={{ fontSize: '18px' }} />
                    </IconButton>
                ),
            });
        }


        setColumns(dynamicColumns)
    }, [status])

    const handleDownloadCsv = () => {
        const header = ["Request Date", "Client ID", "Name", "Email", "Phone No", "Status"]

        if (status !== "Pending") {
            header.push(
                status === "Rejected" ? "Rejected On" : "Approved On",
                status === "Rejected" ? "Rejected By" : "Approved By"
            );
        }

        if (status === "Rejected") {
            header.push(
                "Remark"
            )
        }


        const data = filteredList.map(item => {
            const row = {
                [header[0]]: item.created_at,
                [header[1]]: item.client_id,
                [header[2]]: item.full_name,
                [header[3]]: item.email,
                [header[4]]: item.mobile_number,
                [header[5]]: item.verification_status
            }

            if (status !== "Pending") {
                row[status === "Rejected" ? "Rejected On" : "Approved On"] = item.verified_at?.split("T")[0] || "-";
                row[status === "Rejected" ? "Rejected By" : "Approved By"] = item.verified_by || "-";
            }

            if (status === "Rejected") {
                row["Remark"] = item.verified_comments || "-";
            }

            return row
        })

        exportFromJSON({
            data,
            fileName: 'user_profile_List',
            exportType: exportFromJSON.types.csv
        })
    }

    const handleFilterChange = (event) => {
        const value = event.target.value
        setSelectUpdateType(value)

        if (value === "all") {
            setFilteredList(userList)
        } else {
            const filtered = userList.filter(
                (user) => user.update_type === value
            )
            setFilteredList(filtered)
        }
    }


    return (
        <Grid container direction="column" sx={{ padding: '0px 0px 0px 0px' }}>
            {/* Filter Form */}
            <form className={classes.usFormDateField} onSubmit={handleFormSubmit}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <Grid container spacing={2} alignItems="center">
                        <Grid item>
                            <DatePicker
                                label="From"
                                format="DD-MM-YYYY"
                                InputLabelProps={{ shrink: true }}
                                InputProps={{ className: classes.input }}
                                className={classes.datePicker}
                                value={Fdate ? dayjs(Fdate) : null}
                                onChange={handleFDate}
                            />
                        </Grid>

                        <Grid item>
                            <DatePicker
                                label="To"
                                format="DD-MM-YYYY"
                                InputLabelProps={{ shrink: true }}
                                InputProps={{ className: classes.input }}
                                className={classes.datePicker}
                                value={Tdate ? dayjs(Tdate) : null}
                                onChange={handleTDate}
                            />
                        </Grid>

                        <Grid item>
                            <Button
                                type="submit"
                                sx={{
                                    width: 100,
                                    height: 34,
                                    backgroundColor: '#F44748',
                                    color: '#fff',
                                    fontFamily: 'cardiuma-regular',
                                    fontSize: 11,
                                }}
                            >
                                Submit
                            </Button>
                        </Grid>

                        <Grid item>
                            <Button
                                onClick={handleReset}
                                sx={{
                                    width: 100,
                                    height: 34,
                                    backgroundColor: '#F44748',
                                    color: '#fff',
                                    fontFamily: 'cardiuma-regular',
                                    fontSize: 11,
                                }}
                            >
                                Reset
                            </Button>
                        </Grid>

                        <Grid item>
                            <Button
                                onClick={handleDownloadCsv}
                                sx={{
                                    color: '#F3D45E',
                                    textDecoration: 'underline',
                                    fontFamily: 'cardiuma-regular',
                                    fontSize: '13px',
                                    fontStyle: 'normal',
                                    fontWeight: 'bold',
                                }}
                            >
                                Download CSV
                            </Button>
                        </Grid>

                        <Grid item sx={{ minWidth: 200 }}>
                            <FormControl size="small" fullWidth>
                                <InputLabel className={classes.inputColor} id="status-select-label">
                                    Status
                                </InputLabel>
                                <Select
                                    labelId="status-select-label"
                                    value={status}
                                    onChange={handleStatusChangeDropDown}
                                    displayEmpty
                                    className={classes.select}
                                    sx={{
                                        height: 40,
                                        '.MuiSelect-icon': {
                                            color: 'white !important',
                                        },
                                    }}
                                    MenuProps={{
                                        PaperProps: {
                                            style: { top: '50px' },
                                        },
                                    }}
                                >
                                    {['Pending', 'Approved', 'Rejected'].map((item) => (
                                        <MenuItem key={item} value={item} className={classes.intSelText}>
                                            {item}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>

                        <Grid item sx={{ minWidth: 200 }}>
                            <FormControl size="small" fullWidth>
                                <InputLabel className={classes.inputColor} id="status-select-label">
                                    Update Type
                                </InputLabel>
                                <Select
                                    labelId="status-select-label"
                                    value={selectUpdateType}
                                    onChange={handleFilterChange}
                                    displayEmpty
                                    className={classes.select}
                                    sx={{
                                        height: 40,
                                        '.MuiSelect-icon': {
                                            color: 'white !important',
                                        },
                                    }}
                                    MenuProps={{
                                        PaperProps: {
                                            style: { top: '50px' },
                                        },
                                    }}
                                >
                                    {updateType.map((item) => (
                                        <MenuItem key={item} value={item} className={classes.intSelText}>
                                            {item}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                    </Grid>

                </LocalizationProvider>
            </form>
            {fterror && <Typography color="error" sx={{ fontSize: "14px" }} mb={1} >{fterror}</Typography>}

            {/* Data Grid */}
            <Paper
                className={classes.horizantalTablayout}
            >
                <DataGrid
                    rows={filteredList}
                    columns={columns}
                    className={classes.customDataGrid}
                    sx={{
                        "--DataGrid-containerBackground": "#131E2E",
                        "--DataGrid-rowBorderColor": "#000",
                        border: 0,
                        width: "100%",
                    }}
                    initialState={{
                        pagination: {
                            paginationModel: { page: 0, pageSize: 25 },
                        },
                    }}
                    pageSizeOptions={[25, 50, 75, 100]}
                    getRowId={(row) => row.id}
                />
            </Paper>

            <Modal
                open={editModal}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                userData={userData}
            >
                <Box
                    sx={{ ...style, padding: "20px" }}
                >
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            textAlign: "center",
                            width: "100%",
                            position: "relative",
                        }}
                    >
                        <Typography
                            id="modal-modal-title"
                            variant="h6"
                            component="h2"
                            sx={{
                                fontFamily: "cardiuma-M",
                                fontWeight: "bold",
                            }}
                        >
                            User Profile Modify
                        </Typography>

                        {/* Close Button */}
                        <Button
                            onClick={handleClose}
                            sx={{
                                minWidth: "unset",
                                padding: "0",
                                position: "absolute",
                                right: 0,
                                top: 0,
                            }}
                        >
                            <CloseIcon style={{ color: "red" }} />
                        </Button>
                    </Box>

                    <Grid container sx={{ paddingTop: "20px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                        {
                            [
                                { label: "ClientId", value: userData.client_id },
                                { label: "Update Request", value: userData.update_type?.toUpperCase() },
                                { label: "Existing Details", value: userData.old_value },
                                { label: "New Details", value: userData.new_value },
                                ...(userData.verified_comments ? [{ label: "Comments", value: userData.verified_comments }] : []),
                                { label: "Esign", value: userData.stage },
                                { label: "Completed at", value: userData?.completed_at ? userData.completed_at.split("T")[0] : "N/A" },

                                ...(userData.status !== "Initialized"
                                    ? [
                                        {
                                            label: "Download document",
                                            value: (
                                                <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                                                    {userData.pdf_filename && (
                                                        <Typography component='span' sx={{ fontFamily: "cardiuma-regular !important" }}>{userData.pdf_filename.split("/").pop()}</Typography>
                                                    )}
                                                    <Tooltip title={userData.pdf_filename?.split("/").pop() || "No document"} arrow>
                                                        <IconButton
                                                            onClick={() => downloadDocument(userData.pdf_filename?.split("/").pop(), userData.id, userData.client_id)}
                                                            disabled={!userData.pdf_filename} // Disable if no document is available
                                                        >
                                                            <Download sx={{ color: userData.pdf_filename ? "#42a0f7 !important" : " #999 !important" }} />
                                                        </IconButton>
                                                    </Tooltip>

                                                </div>
                                            ),
                                        }
                                        ,
                                    ]
                                    : []),

                                ...(userData.verification_status === "pending"
                                    ? [
                                        {
                                            label: "Change status",
                                            value: (
                                                <Grid style={{ marginLeft: "0px", borderRadius: "5px" }}>
                                                    <Select value={changeStatus} onChange={(e) => { if (e.target.value == "approved") { setRemarkErr("") } setChangeStatus(e.target.value) }} displayEmpty variant="outlined">
                                                        <MenuItem value="">Pending</MenuItem>
                                                        <MenuItem value="approved">Approve</MenuItem>
                                                        <MenuItem value="rejected">Reject</MenuItem>
                                                    </Select>
                                                </Grid>
                                            ),
                                        },
                                    ]
                                    : []),

                                ...(changeStatus === "rejected"
                                    ? [
                                        {
                                            label: "Rejection Remarks",
                                            value: (
                                                <TextField
                                                    rows={1}
                                                    fullWidth
                                                    value={rejectionRemarks}
                                                    onChange={(e) => setRejectionRemarks(e.target.value)}
                                                    placeholder="Please provide reason for rejection"
                                                    variant="outlined"
                                                    required
                                                    sx={{ marginTop: "10px" }}
                                                />
                                            ),
                                        },

                                    ]
                                    : []),
                            ]
                                .map((item, index) => (
                                    <Grid container key={index} sx={{ marginBottom: "16px" }}>
                                        {/* Label Column */}
                                        <Grid
                                            item
                                            lg={4}
                                            sx={{
                                                textAlign: "right",
                                                paddingRight: "20px",
                                                fontWeight: "bold",
                                                fontFamily: "cardiuma-M",
                                                paddingLeft: "20px",
                                            }}
                                        >
                                            <Typography sx={{ fontFamily: "cardiuma-M" }}>{item.label}:</Typography>
                                        </Grid>

                                        {/* Value Column */}
                                        <Grid
                                            item
                                            lg={8}
                                            sx={{
                                                wordWrap: "break-word",
                                                whiteSpace: "pre-wrap",
                                                paddingLeft: "20px",
                                            }}
                                        >
                                            {typeof item.value === "string" || typeof item.value === "number" ? (
                                                <Typography sx={{ fontFamily: "cardiuma-regular" }}>{item.value || "\u00A0"}</Typography>
                                            ) : (
                                                item.value
                                            )}
                                        </Grid>
                                    </Grid>
                                ))}
                    </Grid>
                    {
                        remarkErr && (
                            <Typography sx={{ textAlign: 'center', }} color="error">
                                {remarkErr}
                            </Typography>
                        )
                    }

                    <Grid
                        sx={{
                            display: "flex",
                            justifyContent: "flex-end",
                            paddingRight: "50px",
                            paddingBottom: "10px",
                        }}
                    >
                        <Button
                            onClick={() => handleSaveStatusChange(userData.id)}
                            sx={{
                                fontFamily: "cardiuma-regular",
                                color: "#ffffff",
                                background: "#F44748",
                                width: "80px",
                                height: "35px",
                                "&:hover": {
                                    background: "#F44748", // Keep the same color on hover
                                },
                                "&.Mui-disabled": {
                                    background: "#D3D3D3", // Custom color for disabled state
                                    color: "#ffffff", // Keep the text color
                                },
                            }}
                            disabled={(!(changeStatus === "rejected" || changeStatus === "approved")) && !rejectionRemarks}
                        >
                            Save
                        </Button>
                    </Grid>

                </Box>
            </Modal>
        </Grid>
    );

}

export default withStyles(styles)(UserProfile)
